module.exports = Date.now;



// WEBPACK FOOTER //
// ./lib/support/now.js